export default {
  'userandregister.login.userName': 'userName',
  'userandregister.login.password': 'password',
  'userandregister.login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'userandregister.login.message-invalid-verification-code': 'Invalid verification code',
  'userandregister.login.tab-login-credentials': 'Credentials',
  'userandregister.login.tab-login-mobile': 'Mobile number',
  'userandregister.login.remember-me': 'Remember me',
  'userandregister.login.forgot-password': 'Forgot your password?',
  'userandregister.login.sign-in-with': 'Sign in with',
  'userandregister.login.signup': 'Sign up',
  'userandregister.login.login': 'Login',
  'userandregister.register.register': 'Register',
  'userandregister.register.get-verification-code': 'Get code',
  'userandregister.register.sign-in': 'Already have an account?',
  'userandregister.register-result.msg': 'Account：registered at {email}',
  'userandregister.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'userandregister.register-result.back-home': 'Back to home',
  'userandregister.register-result.view-mailbox': 'View mailbox',
  'userandregister.email.required': 'Please enter your email!',
  'userandregister.email.wrong-format': 'The email address is in the wrong format!',
  'userandregister.userName.required': 'Please enter your userName!',
  'userandregister.password.required': 'Please enter your password!',
  'userandregister.password.twice': 'The passwords entered twice do not match!',
  'userandregister.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'userandregister.strength.strong': 'Strength: strong',
  'userandregister.strength.medium': 'Strength: medium',
  'userandregister.strength.short': 'Strength: too short',
  'userandregister.confirm-password.required': 'Please confirm your password!',
  'userandregister.phone-number.required': 'Please enter your phone number!',
  'userandregister.phone-number.wrong-format': 'Malformed phone number!',
  'userandregister.verification-code.required': 'Please enter the verification code!',
  'userandregister.title.required': 'Please enter a title',
  'userandregister.date.required': 'Please select the start and end date',
  'userandregister.goal.required': 'Please enter a description of the goal',
  'userandregister.standard.required': 'Please enter a metric',
  'userandregister.form.get-captcha': 'Get Captcha',
  'userandregister.captcha.second': 'sec',
  'userandregister.form.optional': ' (optional) ',
  'userandregister.form.submit': 'Submit',
  'userandregister.form.save': 'Save',
  'userandregister.email.placeholder': 'Email',
  'userandregister.password.placeholder': 'Password',
  'userandregister.confirm-password.placeholder': 'Confirm password',
  'userandregister.phone-number.placeholder': 'Phone number',
  'userandregister.verification-code.placeholder': 'Verification code',
  'userandregister.title.label': 'Title',
  'userandregister.title.placeholder': 'Give the target a name',
  'userandregister.date.label': 'Start and end date',
  'userandregister.placeholder.start': 'Start date',
  'userandregister.placeholder.end': 'End date',
  'userandregister.goal.label': 'Goal description',
  'userandregister.goal.placeholder': 'Please enter your work goals',
  'userandregister.standard.label': 'Metrics',
  'userandregister.standard.placeholder': 'Please enter a metric',
  'userandregister.client.label': 'Client',
  'userandregister.label.tooltip': 'Target service object',
  'userandregister.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'userandregister.invites.label': 'Inviting critics',
  'userandregister.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'userandregister.weight.label': 'Weight',
  'userandregister.weight.placeholder': 'Please enter weight',
  'userandregister.public.label': 'Target disclosure',
  'userandregister.label.help': 'Customers and invitees are shared by default',
  'userandregister.radio.public': 'Public',
  'userandregister.radio.partially-public': 'Partially public',
  'userandregister.radio.private': 'Private',
  'userandregister.publicUsers.placeholder': 'Open to',
  'userandregister.option.A': 'Colleague A',
  'userandregister.option.B': 'Colleague B',
  'userandregister.option.C': 'Colleague C',
  'userandregister.navBar.lang': 'Languages',
};
